export default "__VITE_ASSET__xQDc9IvJ__"